import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import { ApiUrlConstant } from "../../../../constants/api-url.constant";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
@Injectable()
export class TransferWorstODPairsService {
  apiUrl = environment.gateWayHost;
  constructor(
    public generic: GenericHttpService,
    private urlConstant: ApiUrlConstant
  ) {}

  getWorstODPairs(param, query): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.apiUrl}${param.api}`,
      query: query
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }
}
